module.exports = __webpack_public_path__ + "img/ce.svg.032ac6ce.png";